// libraries
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Breadcrumbs from '/react4xp/components/Breadcrumbs'
import Image, { ImageProps } from '/react4xp/components/Image'

// css
import './index.scss'

// types
export interface HeroProps {
    className?: string
    layout?: 'full' | 'two-columns'
    breadcrumbs?: {
        label: string
        url?: string
    }[]
    image?: ImageProps
    title?: string
    description?: string
    button?: {
        label: string
        url?: string
        external?: boolean
    }
}

export default function Hero({
    className,
    layout,
    breadcrumbs,
    image,
    title,
    description,
    button
}: HeroProps) {
    return (
        <Section
            className={clsx('hero-component', className)}
            removeMarginTop
        >
            <div className='container'>

                {layout === 'full' ? (
                    <div className='hero-component__full'>

                        {image?.src?.src && (
                            <>
                                {/* desktop image */}
                                <Image
                                    src={{
                                        src: image?.src?.src || '',
                                        width: 1600, // 1600
                                        height: 800 // 800
                                    }}
                                    srcLarge={{
                                        src: image?.srcLarge?.src || '',
                                        width: 1320, // 1320
                                        height: 665 // 665
                                    }}
                                    alt={image?.alt || ''}
                                    className='cover hero-component__image hero-component__image--desktop'
                                    sizes='100vw'
                                    lazyLoad={false}
                                />

                                {/* mobile image */}
                                <Image
                                    src={{
                                        src: image?.srcMedium?.src || '',
                                        width: 1024, // 1024
                                        height: 1072 // 1072
                                    }}
                                    srcSmall={{
                                        src: image?.srcSmall?.src || '',
                                        width: 720, // 720
                                        height: 760 // 760
                                    }}
                                    alt={image?.alt || ''}
                                    className='cover hero-component__image hero-component__image--mobile'
                                    sizes='100vw'
                                    lazyLoad={false}
                                />
                            </>
                        )}

                        <div className='hero-component__full__side-box'>
                            <Content
                                title={title}
                                description={description}
                                button={button}
                            />
                        </div>

                    </div>
                ) : (
                    <div className='hero-component__two-columns'>
                        <div className='row'>
                            
                            <div className={clsx(
                                image?.src?.src ? 'col-12 col-lg-6' : 'col-12 col-lg-6 offset-lg-3',
                                'hero-component__two-columns__content'
                            )}>

                                {breadcrumbs && (
                                    <Breadcrumbs
                                        items={breadcrumbs}
                                        className='hero-component__two-columns__breadcrumbs'
                                    />
                                )}

                                <Content
                                    title={title}
                                    description={description}
                                    button={button}
                                />

                            </div>

                            {image?.src?.src && (
                                <div className='col-12 col-lg-6'>
                                    <div className='hero-component__two-columns__image'>
                                        <Image
                                            src={{
                                                src: image?.src?.src || '',
                                                width: 650, // 650
                                                height: 550 // 550
                                            }}
                                            alt={image?.alt || ''}
                                            className='cover'
                                            lazyLoad={false}
                                        />
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                )}
               
            </div>
        </Section>
    )
}

export function Content({
    title,
    description,
    button
}: HeroProps) {
    return (
        <>
            {title && (
                <h1 className='h1'>
                    {title}
                </h1>
            )}

            {description && (
                <p
                    className='lead-paragraph'
                    dangerouslySetInnerHTML={{ __html: description }}
                    suppressHydrationWarning
                />
            )}

            {button && (
                <a
                    href={button.url}
                    target={button.external ? '_blank' : '_self'}
                    rel={button.external ? 'noopener noreferrer' : ''}
                    className='button-black'
                >
                    {button.label}
                </a>
            )}
        </>
    )
}